module.exports = __webpack_public_path__ + "static/img/combined-bottom.dedfcdc1.png";